"use client";

import { Navbar, Dropdown, Avatar, Badge } from "flowbite-react";
import { Link } from "react-router-dom";
import { MdDashboard } from "react-icons/md";
import { Button } from "antd";





const Header = () => {
  return (
    <Navbar fluid rounded className="mb-3 border-b-2 py-1 pb-0">
      <div className="flex">
        <Link className="me-3 p-2 border-2 rounded hover:text-blue-500" to={'/'}>{<MdDashboard />}</Link>
        <Navbar.Brand as={Link} to={'/inventory/'} className="w-50">
          <span className="self-center whitespace-nowrap text-xl font-semibold dark:text-white">Inventory</span>
        </Navbar.Brand>
      </div>
      <div className="flex">
        <Dropdown arrowIcon={false} inline label={<span className="mx-2">Products</span>}>
          <Dropdown.Item as={Link} to={'/inventory/products'}>Products</Dropdown.Item>
          <Dropdown.Item as={Link} to={'/inventory/packages'}>Packages</Dropdown.Item>
          <Dropdown.Item as={Link} to={'/inventory/lots-serial-numbers'}>Lot/Serial Numbers</Dropdown.Item>
          <Dropdown.Item as={Link} to={'/inventory/product-tags'}>Product Tags</Dropdown.Item>
          
        </Dropdown>

        <Dropdown arrowIcon={false} inline label={<span className="mx-2">Operations</span>}>
          <Dropdown.Item as={Link} to={'/inventory/transfers'}>Transfers</Dropdown.Item>
          <Dropdown.Item as={Link} to={'/inventory/transfers/pick-laters'}>Pick Later Transfers</Dropdown.Item>
          <Dropdown.Item as={Link} to={'/inventory/stock-request'}>Stock Requests</Dropdown.Item>
          <Dropdown.Item as={Link} to={'/inventory/inventory-adjustments'}>Inventory Adjustments</Dropdown.Item>
          <Dropdown.Item as={Link} to={'/inventory/stock-counts'}>Stock Counts</Dropdown.Item>
          <Dropdown.Item as={Link} to={'/inventory/replenishments'}>Replenishments</Dropdown.Item>
        </Dropdown>

        <Dropdown arrowIcon={false} inline label={<span className="mx-2">Reports</span>}>
          <Dropdown.Item as={Link} to={'/inventory/reports/inventory-stock'}>Inventory Stock</Dropdown.Item>
          <Dropdown.Item as={Link} to={'/inventory/reports/moves-history'}>Moves History</Dropdown.Item>
        </Dropdown>

        <Dropdown arrowIcon={false} inline label={<span className="mx-2">Configurations</span>}>
          <Dropdown.Item>Settings</Dropdown.Item>
          <Badge className="text-slate-600 bg-transparent	">Warehouse Manangement</Badge>
          <Dropdown.Item as={Link} to={'/inventory/warehouses'}>Warehouses</Dropdown.Item>
          <Dropdown.Item as={Link} to={'/inventory/locations'}>Locations</Dropdown.Item>
          <Dropdown.Item as={Link} to={'/inventory/routes'}>Routes</Dropdown.Item>
          <Dropdown.Item as={Link} to={'/inventory/operation-types'}>Operation Types</Dropdown.Item>
          <Dropdown.Item as={Link} to={'/inventory/putawayrules'}>Putaway Rules</Dropdown.Item>

          <Badge className="text-slate-600 bg-transparent	">Products</Badge>
          <Dropdown.Item as={Link} to={'/inventory/product-categories'}>Product Cateogries</Dropdown.Item>
          <Dropdown.Item as={Link} to={'/inventory/attributes'}>Attributes</Dropdown.Item>
          <Dropdown.Item as={Link} to={'/inventory/packaging'}>Product Packaging</Dropdown.Item>
          <Dropdown.Item as={Link} to={'/inventory/reordering'}>Reordering</Dropdown.Item>

          <Badge className="text-slate-600 bg-transparent	">Delivery</Badge>
          <Dropdown.Item as={Link} to={'/inventory/shipping-methods'}>Shipping Methods</Dropdown.Item>
          <Dropdown.Item as={Link} to={'/inventory/package-types'}>Package Types</Dropdown.Item>
        </Dropdown>
      </div>
      <div className="">
        
        <Dropdown
          arrowIcon={false}
          inline
          label={
            <Avatar alt="User settings" img="https://flowbite.com/docs/images/people/profile-picture-5.jpg" rounded />
          }
        >
          <Dropdown.Header>
            <span className="block text-sm">Bonnie Green</span>
            <span className="block truncate text-sm font-medium">name@flowbite.com</span>
          </Dropdown.Header>
          <Dropdown.Item>Dashboard</Dropdown.Item>
          <Dropdown.Item>Settings</Dropdown.Item>
          <Dropdown.Item>Earnings</Dropdown.Item>
          <Dropdown.Divider />
          <Dropdown.Item>Sign out</Dropdown.Item>
        </Dropdown>
        {/* <Navbar.Toggle /> */}
      </div>
      {/* <Navbar.Collapse>
        <Navbar.Link href="#" active>
          Home
        </Navbar.Link>
        <Navbar.Link href="#">About</Navbar.Link>
        <Navbar.Link href="#">Services</Navbar.Link>
        <Navbar.Link href="#">Pricing</Navbar.Link>
        <Navbar.Link href="#">Contact</Navbar.Link>
      </Navbar.Collapse> */}
    </Navbar>
  );
}




export default Header;